import { render, staticRenderFns } from "./school-wise-performance-report.vue?vue&type=template&id=5816938a&scoped=true&"
import script from "./school-wise-performance-report.vue?vue&type=script&lang=js&"
export * from "./school-wise-performance-report.vue?vue&type=script&lang=js&"
import style0 from "./school-wise-performance-report.vue?vue&type=style&index=0&id=5816938a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816938a",
  null
  
)

export default component.exports